import React from 'react';
import './PsTable.css';

export const PsTable = (
    {
        headings,
        children,
    },
) => {
    return (
        <div className="ps-table-container">
            <table className="table table-hover">
                <thead>
                    {headings}
                </thead>
                <tfoot>
                    {headings}
                </tfoot>
                <tbody>
                    {children}
                </tbody>
            </table>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/app/shared/components/table/PsTable.jsx